/**
 * To set digital data for Adobe DTM
 */
const win = window as any;

export function setDigitalData(digitalData: { [key: string]: any }) {
  if (Object.keys(digitalData).length === 0) resetDigitalData();
  win.digitalData = { ...win.digitalData, ...digitalData };
}

export function modifyDigitalData(prop: string) {
  const propKey = prop;
  const { [propKey]: propVal, ...rest } = win.digitalData;
  win.digitalData = rest;
}

function resetDigitalData() {
  const {
    TestsearchData,
    eventData,
    internalSearch,
    pageData,
    pageData1,
    resultsData,
    siteData,
    siteData1,
    sponsoredProducts,
    userData,
    userData1,
    userGUID,
  } = win.digitalData || {};

  win.digitalData = {
    TestsearchData,
    eventData,
    internalSearch,
    pageData,
    pageData1,
    resultsData,
    siteData,
    siteData1,
    sponsoredProducts,
    userData,
    userData1,
    userGUID,
  };
}
